var _circle, _circle2, _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeposit = function SvgDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 24,
    fill: "#7D6E5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Deposit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Deposit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#000",
    d: "M-4 0h22v24H-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37,
    cy: 39,
    r: 15,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Deposit_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 22,
    width: 39,
    height: 28,
    rx: 3,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Deposit_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 19,
    width: 39,
    height: 28,
    rx: 3,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Deposit_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 15,
    width: 38,
    height: 28,
    rx: 3,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 41a2 2 0 0 1-2-2V19a2 2 0 0 1 2-2h23a7 7 0 0 0 7 7v10a7 7 0 0 0-7 7H1Z",
    fill: "url(#Deposit_svg__e)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 13,
    cy: 29,
    r: 9,
    fill: "#D1B896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 25.423V24.5h-1v.93c-1.371.16-2.313.968-2.313 2.064 0 1.032.642 1.624 2.025 1.936l.288.063v1.954c-.565-.109-.922-.402-1.063-.82H10c.115 1.109 1.046 1.824 2.5 1.952v.921h1v-.926c1.47-.155 2.5-.978 2.5-2.151 0-1.019-.648-1.585-2.031-1.89l-.469-.105v-1.87c.536.105.879.39.983.79h1.377c-.126-1.097-1-1.793-2.36-1.925Zm-1 1.146c-.534.12-.896.431-.896.849 0 .365.286.612.896.783v-1.633Zm1 3.145v1.738c.634-.111 1.05-.447 1.05-.896 0-.41-.335-.676-1.05-.842Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#Deposit_svg__f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 15.5,
    r: 12.5,
    fill: "#2F5EA7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 21.571V9M30 16.071l5.5 5.5 5.5-5.5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Deposit_svg__b",
    x: -20,
    y: 20,
    width: 51,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.320935 0 0 0 0 0.405578 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_88_2019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Deposit_svg__c",
    x: -17,
    y: 17,
    width: 51,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.633333 0 0 0 0 0.555061 0 0 0 0 0.448611 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_88_2019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Deposit_svg__d",
    x: -13,
    y: 13,
    width: 50,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.666667 0 0 0 0 0.563088 0 0 0 0 0.422222 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_88_2019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Deposit_svg__f",
    x: 16,
    y: 0,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.207104 0 0 0 0 0.405578 0 0 0 0.502439 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_2019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_88_2019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deposit_svg__e",
    x1: -1,
    y1: 41,
    x2: 31,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgDeposit;